/* src/contexts/profile/profileActionsOnboarding.js */
import { useCallback } from 'react';

/**
 * Hook creator for Mark Onboarding Complete action.
 */
export const useCreateMarkOnboardingCompleteAction = (
    setIsOnboardingComplete // Needs setter
) => {
    return useCallback(() => {
        console.log("[ProfileContext Action] Marking onboarding as complete.");
        setIsOnboardingComplete(true);
    }, [setIsOnboardingComplete]);
};